import { Fragment } from 'react';
import type { NextPage } from 'next';
import SEO from 'components/common/SEO';
import GeoAudit from 'components/common/GeoAudit';
import { Footer1 } from 'components/blocks/footer';
import * as All from 'data/keywords';

// Dedicated page for the AI Visibility Audit tool. Own page so the tool can grow/auto-scroll
// freely without disturbing the homepage. No bodyClass => solid, readable navbar (not the
// transparent over-hero state). Nav is global (rendered in _app.tsx).
const AiVisibility: NextPage = () => {
  return (
    <>
      <SEO
        title={'AI Visibility Audit'}
        description={'See how visible your brand is in AI answers - ChatGPT, Gemini, Claude, Perplexity and Google AI Overviews. Enter your domain for a free check.'}
        tag={'seo, ai visibility'}
        urlPT={``}
        urlENPT={``}
        url={`ai-visibility`}
        image={``}
      />
      <Fragment>
        <main className="content-wrapper">
          <section className="wrapper bg-light">
            <div className="container pt-md-11 pt-lg-14 pb-14 pb-md-16 geo-embed-section">
              <div className="mb-8 mb-md-10 geo-embed-heading" style={{ maxWidth: '720px', marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
                <h1 className="display-3 mb-3">Test your site in AI answers</h1>
                <p className="lead">
                  Enter your domain. We read your site, find your real competitors, and check what
                  ChatGPT, Gemini, Claude, Perplexity and Google AI Overviews say about you.
                </p>
              </div>
              <GeoAudit />
            </div>
          </section>
        </main>
        <Footer1
          address={[
            <>
              {All.SiteIdentity[0].address1},<br /> {All.SiteIdentity[0].address2},<br /> {All.SiteIdentity[0].address3}
            </>
          ]}
          email={All.SiteIdentity[0].email}
          phone={All.SiteIdentity[0].phone}
        />
      </Fragment>
    </>
  );
};

export default AiVisibility;
